import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const EMOTICON_SIZE = 48;

type ScoreProps = {
  store?: boolean;
};

export const Score = styled.div<ScoreProps>(
  p => css`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    font-size: 24px;
    line-height: normal;
    color: ${p.theme.text.primary};

    ${!p.store &&
      css`
        margin-left: ${layout.measurements.spacing050};
        margin-right: ${layout.measurements.spacing025};
      `};

    ${p.store &&
      css`
        align-self: flex-start;
      `}
  `
);

export const Divider = styled.span`
  &::after {
    margin: 0 ${layout.measurements.spacing050};
    content: '•';
  }
`;

export const Rating = styled.div``;

export const Count = styled.div``;

export const ProductRating = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${layout.measurements.spacing025};
  align-items: center;

  ${Score} {
    font-size: ${layout.measurements.fontSizeMega};
  }
`;

export const ShopRating = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  column-gap: ${layout.measurements.spacing050};

  ${Rating} {
    grid-area: 1 / 1 / 3 / 2;
  }

  ${Score} {
    grid-area: 1 / 2 / 2 / 3;
  }

  ${Count} {
    grid-area: 2 / 2 / 3 / 3;
  }
`;
